var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGbr = function SvgGbr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 85.333h512V426.67H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M288 85.33h-64v138.666H0v64h224v138.666h64V287.996h224v-64H288z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M393.785 315.358L512 381.034v-65.676zm-82.133 0L512 426.662v-31.474l-143.693-79.83zm146.982 111.304l-146.982-81.664v81.664z",
    fill: "#0052B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M311.652 315.358L512 426.662v-31.474l-143.693-79.83z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M311.652 315.358L512 426.662v-31.474l-143.693-79.83z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.341 315.356L0 365.546v-50.19zm110.007 14.154v97.151H25.491z",
    fill: "#0052B4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M143.693 315.358L0 395.188v31.474l200.348-111.304z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118.215 196.634L0 130.958v65.676zm82.133 0L0 85.33v31.474l143.693 79.83zM53.366 85.33l146.982 81.664V85.33z",
    fill: "#0052B4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M200.348 196.634L0 85.33v31.474l143.693 79.83z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M200.348 196.634L0 85.33v31.474l143.693 79.83z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M421.659 196.636L512 146.446v50.19zm-110.007-14.154V85.331h174.857z",
    fill: "#0052B4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M368.307 196.634L512 116.804V85.33L311.652 196.634z"
  })));
};
export { SvgGbr as ReactComponent };